import axios from "../app/axios";

const WhoAmI = () => {
  return axios().get("/whoami");
};


export default WhoAmI;
